import { render, staticRenderFns } from "./pointInfo.vue?vue&type=template&id=42b466c6&scoped=true"
import script from "./pointInfo.vue?vue&type=script&lang=js"
export * from "./pointInfo.vue?vue&type=script&lang=js"
import style0 from "./pointInfo.vue?vue&type=style&index=0&id=42b466c6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b466c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b466c6')) {
      api.createRecord('42b466c6', component.options)
    } else {
      api.reload('42b466c6', component.options)
    }
    module.hot.accept("./pointInfo.vue?vue&type=template&id=42b466c6&scoped=true", function () {
      api.rerender('42b466c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/pointInfo.vue"
export default component.exports